module.exports = __webpack_public_path__ + "static/media/ic_left.ac61b5f7.svg";